import styles from './styles/Badge.css'
import classNames from 'classnames'
import Tooltip from 'components/misc/Tooltip'

const Badge = ({ className = '', tooltipCopy = '', children }) => {
  return (
    <span className={classNames(styles.pill, className)}>
      {tooltipCopy
        ? (
          <Tooltip
            placement='bottom'
            content={tooltipCopy}
          >
            <span className={styles.status}>
              {children}
            </span>
          </Tooltip>
          )
        : (
          <span className={styles.status}>
            {children}
          </span>
          )}
    </span>
  )
}

export default Badge
